import React from 'react';
const readItemNodesRecursively = (parentItemNode, children) => {
    if (!children) {
        return;
    }
    React.Children.toArray(children).forEach(child => {
        var _a, _b, _c;
        if (!React.isValidElement(child)) {
            return;
        }
        const itemKey = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.itemKey;
        const itemChildren = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.children;
        if (typeof itemKey === 'string' && itemKey !== parentItemNode.itemKey) {
            const itemNode = { itemKey };
            ((_c = parentItemNode.items) !== null && _c !== void 0 ? _c : (parentItemNode.items = [])).push(itemNode);
            readItemNodesRecursively(itemNode, itemChildren);
        }
        else {
            readItemNodesRecursively(parentItemNode, itemChildren);
        }
    });
};
const readParentKeysRecursively = (keyToParentKey, itemNodes, parentItemKey) => {
    for (const { itemKey, items } of itemNodes) {
        keyToParentKey[itemKey] = parentItemKey;
        if (items) {
            readParentKeysRecursively(keyToParentKey, items, itemKey);
        }
    }
};
/**
 * Recursively walks react children to create a tree of sidebar item nodes and
 * their parent-child relationships.
 */
export const extractItemNodes = (children) => {
    var _a;
    const rootNode = { itemKey: 'rootMenu' }; // TODO: use a symbol
    readItemNodesRecursively(rootNode, children);
    const items = (_a = rootNode.items) !== null && _a !== void 0 ? _a : [];
    const keyToParentKey = Object.create(null);
    readParentKeysRecursively(keyToParentKey, items);
    return { items, keyToParentKey };
};
export const getItemPath = (keyToParentKey, itemKey) => {
    const path = [];
    while (itemKey !== undefined) {
        path.unshift(itemKey);
        itemKey = keyToParentKey[itemKey];
    }
    return path;
};
export const isMenu = (keyToParentKey, itemKey) => Object.values(keyToParentKey).includes(itemKey);
export const getMenuPath = (keyToParentKey, itemKey) => {
    const path = getItemPath(keyToParentKey, itemKey);
    if (path.length > 0 && !isMenu(keyToParentKey, path[path.length - 1])) {
        path.pop();
    }
    return path;
};
export const getMaxDepth = (items) => {
    let maxDepth = 0;
    if (items === null || items === void 0 ? void 0 : items.length) {
        for (const item of items) {
            maxDepth = Math.max(maxDepth, getMaxDepth(item.items) + 1);
        }
    }
    return maxDepth;
};
export function pick(object, keys) {
    // Probably should use `lodash.pick` but it's too smart with its key handing (
    // lodash keys can be paths like `a.b.c`). Since we're using this to pick
    // keys from a record which gets created from consumer input, we can't be sure
    // that consumers won't use keys that look like paths.
    const result = {};
    for (const key of keys) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
            result[key] = object[key];
        }
    }
    return result;
}
//# sourceMappingURL=utils.js.map